<template>
  <v-card class="py-5">
    <span class="title px-3 my-3">登録済み分析サンプル一覧</span>
    <span class="caption px-3">登録済みの分析サンプル一覧です。  ※分析依頼待ちの分析サンプルが表示されます。依頼済みの分析サンプルは表示されません。</span>
    <v-row dense>
      <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
        <div class="px-3">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          placeholder="採油済みサンプルを検索"
          filled
          dense
        ></v-text-field>
        </div>
      </v-col>

    </v-row>
    <v-row dense>
      <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
        <v-data-table
          :headers="headers"
          :items="samples"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :search="search"
          :sort-by="['createdAt']"
          :sort-desc="[true]"
          class="elevation-1"
          no-data-text="データがありません。"  
          no-results-text="検索条件に該当するデータがありません。"                  
          hide-default-footer
          @page-count="pageCount = $event"
          @click:row="(data) => { $router.push(`${updateSumplingURL(data.MachineID)}?id=${data.id}&mode=update`) }"
        >

          <template v-slot:[`item.SamplingAt`]="{ item }">
            <span v-show="item.SamplingAt"> {{ item.SamplingAt | moment('YYYY[/]MM[/]DD') }} </span>
            <span v-show="!item.SamplingAt"> なし </span>
          </template>

          <template v-slot:[`item.BottleCount`]="{ item }">
            <div class="text-center"> {{ item.BottleCount }} </div>
          </template>
          <template v-slot:[`header.BottleCount`]="{ header }">
              <div  class="mt-4 text-center">{{ header.text }}</div>
          </template>

          <template v-slot:[`header.HazardousMaterialsConfirmed`]="{ header }">
            <div class="mt-4 text-center">{{ header.text }}</div>
          </template>
          <template v-slot:[`item.HazardousMaterialsConfirmed`]="{ item }">
            <div v-if="item.isHazardousMaterials==0" class="text-center">
              <v-icon color="gray">mdi-minus</v-icon>
            </div>
            <div v-else-if="item.HazardousMaterialsConfirmed==1" class="text-center">
              <v-icon color="red">mdi-checkbox-marked-circle</v-icon>
            </div>
            <div v-else class="text-center">
              <v-icon color="gray">mdi-checkbox-marked-circle</v-icon>
            </div>
          </template>

        </v-data-table>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="10"  lg="10" md='8' sm='8' xs="10">
        <!-- <v-pagination v-model="page" color="amber black--text" light circle :length="pageCount"></v-pagination> -->
        <v-pagination
          v-model="page"
          :total-visible="totalVisible"
          :length="pageCount"
          color="amber darken-1 black--text"
          light 
          circle
        >
        </v-pagination>

      </v-col>
      <v-col cols="2"  lg="2"  md='4' sm='4' xs="2">
        <v-select
          :value="itemsPerPage"
          :items = "itemsPerPageList"
          label="1ページの行数"
          @input="itemsPerPage = Number($event)"
        ></v-select>
      </v-col>
    </v-row>
  </v-card >
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"

export default {
  name: 'Mypage',
  data() {
    return {
      dialog: false,

      search: '',
      page: 1,
      pageCount: 0,
      totalVisible: 7,
      itemsPerPage: 5,
      itemsPerPageList: [ 5,10,30 ],
      headers: [
        {
          text: 'サンプル識別名',
          align: 'start',
          sortable: false,
          value: 'Name',
          class: "grey darken-2 white--text",
          width: '25%'
        },
        {
          text: '機器ＩＤ',
          value: 'CustomerMachineID',
          class: "grey darken-2 white--text"
        },
        {
          text: '採取日',
          value: 'SamplingAt',
          class: "grey darken-2 white--text"
        },
        {
          text: 'ボトル数',
          value: 'BottleCount',
          class: "grey darken-2 white--text"
        },
        {
          text: '危険物',
          value: 'HazardousMaterialsConfirmed',
          class: "grey darken-2 white--text"
        },
/*
        {
          text: '削除',
          value: 'actions',
          class: "grey darken-2 white--text"
        },
*/
      ],
      samples: [],
    }
  },
  mounted: async function () {
    //  全カラムの一覧を取る場合はこの1行でOK
    //  let machines = await API.graphql(graphqlOperation(listMachines, {limit: 100, items: "Name,  CustomerMachineID, OperatingTime, OperatingTimeUnit"}))
    //  取得するカラムを指定する場合はこのように書く。
    //
    //サンプリング直後（まだ依頼に出していない）データのOfficeIDは、OfficeID + "-00000000"で設定
    //依頼されたときに、正しいOfficeIDに更新する。    const samplesByOfficeQuery = 
    const samplesByOfficeQuery = `query samplesByOffice {
      samplesByOffice(limit: 999, OfficeID: "` + this.$store.state.operatingOffice.OfficeID + `-00000000") {
        items {
          id
          Name
          MachineID
          CustomerMachineID
          SamplingAt
          ApplicationID
          BottleCount
          isHazardousMaterials
          HazardousMaterialsConfirmed
          createdAt
        }
      }
      }`;
    let samples = await API.graphql(graphqlOperation(samplesByOfficeQuery))
    console.log("samples:", samples);
    this.samples = samples.data.samplesByOffice.items;
  },

  computed : {
  },
  methods: {
/*    
      showDialog() {
        this.$refs.deletedialog.open();
      },
*/
    updateSumplingURL(MachineID) {
        //マイ機器のあるサンプルかどうかによって遷移先を変更
        //マイ機器なし = MachineID:0000000000
        if(MachineID != "0000000000")
          return "/sampling"
        else{
          return "/spotsampling"
        }
      }
  },
}
</script>